<template>
  <div class="top barging-container">
    <div class="flex flex-row justify-between p-1 laptop:pb-2 desktop:pb-8">
      <h2 class="page-title">Bypass Seal Record</h2>
    </div>

    <div class="barging-card" style="padding:0px 0px; background-color:#f2f7fa; border-radius: 10px;">
      <div class="w-full searchBar">
        <div class="flex flex-wrap justify-end">
          <div class="flex flex-row py-2 pr-2">
            <el-date-picker v-model="filters.date" size="mini" clearable placeholder="Date" prefix-icon="el-icon-date"
              type="date" :style="{ width: '150px' }" format="dd/MM/yyyy" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
          <div class="flex flex-row py-2 pr-2">
            <el-select v-model="filters.jettyNo" size="mini" clearable placeholder="Jetty" :style="{ width: '130px' }">
              <el-option v-for="j in jettyOptions" :key="j" :label="'Jetty ' + j" :value="j"></el-option>
            </el-select>
          </div>
          <div class="flex flex-row py-2 pr-2">
            <el-select v-model="filters.shiftType" size="mini" clearable placeholder="Shift"
              :style="{ width: '130px' }">
              <el-option v-for="s in shiftOptions" :key="s.value" :label="s.label" :value="s.value"></el-option>
            </el-select>
          </div>
          <div class="flex flex-row py-2 pr-2">
            <el-select v-model="filters.bypassSeal" size="mini" clearable placeholder="Bypass Seal"
              :style="{ width: '150px' }">
              <el-option v-for="s in bypassSealOptions" :key="s" :label="s" :value="s"></el-option>
            </el-select>
          </div>
          <div class="flex flex-row py-2 pr-2">
            <el-input v-model="filters.searchValue" size="mini" clearable
              placeholder="Search Seal No / Remarks / Username" :style="{ width: '260px' }"></el-input>
          </div>
          <div class="flex flex-row pl-2 py-2">
            <el-button size="mini" type="primary" @click="handleExportExcel">Export Excel</el-button>
          </div>
        </div>
      </div>

      <div class="box-card barging-table" v-bind:class="{ 'mobile-view': isMobileScreen }">
        <div class="w-full Comtable">
          <el-table key="bypassSealTable" :data="pagedData"
            :header-cell-style="{ height: '55px', background: '#fff', 'border-bottom': '2px solid #D6D9E1' }"
            :cell-style="getCellStyle" v-loading="loading" table-layout="auto" height="100%">
            <el-table-column align="center" prop="checkDate" label="Date" min-width="140" :formatter="formatDate"
              sortable></el-table-column>
            <el-table-column align="center" prop="jettyNo" label="Jetty No" min-width="120" sortable></el-table-column>
            <el-table-column align="center" prop="shiftType" label="Shift" min-width="130" :formatter="formatShift"
              sortable></el-table-column>
            <el-table-column align="center" prop="entryNo" label="Entry No" min-width="120" sortable></el-table-column>
            <el-table-column align="center" prop="bypassSeal" label="Bypass Seal" min-width="150"></el-table-column>
            <el-table-column align="center" prop="sealNumber" label="Seal Number" min-width="150"></el-table-column>
            <el-table-column align="center" prop="sealRemarks" label="Seal Remarks" min-width="200"></el-table-column>
            <el-table-column align="center" prop="name" label="Username" min-width="160"></el-table-column>
          </el-table>
        </div>
      </div>

      <div class="barging-pagination">
        <pagination v-show="filteredData.length > 0" :total="filteredData.length" :page.sync="pageNum"
          :limit.sync="pageSize" :pageSizes="[20, 30, 50, 100]" @pagination="() => {}"></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getJettyChecklistList } from "@/services/user";

export default {
  name: "Bypass Seal Record",
  data() {
    return {
      loading: false,
      allData: [],
      bypassSealOptions: ["Break Seal", "Lock Seal", "Area Check"],
      shiftOptions: [
        { label: "Day Shift", value: "DAY" },
        { label: "Night Shift", value: "NIGHT" },
      ],
      filters: {
        date: "",
        jettyNo: "",
        shiftType: "",
        bypassSeal: "",
        searchValue: "",
      },
      pageNum: 1,
      pageSize: 20,
    };
  },
  computed: {
    ...mapState(["screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
    jettyOptions() {
      const set = new Set(
        (this.allData || []).map((r) => r.jettyNo).filter((v) => v !== null && v !== undefined && v !== "")
      );
      return [...set].sort((a, b) => a - b);
    },
    filteredData() {
      const { date, jettyNo, shiftType, bypassSeal, searchValue } = this.filters;
      const kw = (searchValue || "").trim().toLowerCase();
      return (this.allData || []).filter((r) => {
        if (date && (r.checkDate || "").slice(0, 10) !== date) return false;
        if (jettyNo !== "" && jettyNo !== null && r.jettyNo !== jettyNo) return false;
        if (shiftType && r.shiftType !== shiftType) return false;
        if (bypassSeal && r.bypassSeal !== bypassSeal) return false;
        if (kw) {
          const hay = `${r.sealNumber || ""} ${r.sealRemarks || ""} ${r.name || ""}`.toLowerCase();
          if (!hay.includes(kw)) return false;
        }
        return true;
      });
    },
    pagedData() {
      const start = (this.pageNum - 1) * this.pageSize;
      return this.filteredData.slice(start, start + this.pageSize);
    },
  },
  watch: {
    // Any filter change resets to the first page so the view isn't stuck on an empty page.
    filters: {
      deep: true,
      handler() {
        this.pageNum = 1;
      },
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      getJettyChecklistList()
        .then((res) => {
          // Only records that actually carry a bypass seal entry are relevant here.
          this.allData = (res?.data || []).filter((r) => r.bypassSeal);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatDate(row, column, cellValue) {
      return (cellValue || "").slice(0, 10);
    },
    shiftLabel(shiftType) {
      if (shiftType === "DAY") return "Day Shift";
      if (shiftType === "NIGHT") return "Night Shift";
      return shiftType || "";
    },
    formatShift(row, column, cellValue) {
      return this.shiftLabel(cellValue);
    },
    getCellStyle({ rowIndex }) {
      return {
        backgroundColor: rowIndex % 2 === 1 ? "rgba(255,255,255,0.2)" : "rgba(228,228,228,0.2)",
      };
    },
    handleExportExcel() {
      const rows = this.filteredData;
      if (!rows.length) {
        this.$message.warning("No data to export");
        return;
      }
      const headers = ["Date", "Jetty No", "Shift", "Entry No", "Bypass Seal", "Seal Number", "Seal Remarks", "Username"];
      const esc = (v) =>
        String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      const cells = (r) => [
        (r.checkDate || "").slice(0, 10),
        r.jettyNo,
        this.shiftLabel(r.shiftType),
        r.entryNo,
        r.bypassSeal,
        r.sealNumber,
        r.sealRemarks,
        r.name,
      ];
      const body = rows
        .map((r) => `<tr>${cells(r).map((c) => `<td>${esc(c)}</td>`).join("")}</tr>`)
        .join("");
      const html =
        `<html><head><meta charset="utf-8"></head><body><table border="1">` +
        `<thead><tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr></thead>` +
        `<tbody>${body}</tbody></table></body></html>`;
      const blob = new Blob(["﻿" + html], { type: "application/vnd.ms-excel" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "bypass-seal-record-" + new Date().toISOString().slice(0, 10) + ".xls";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped lang="scss">
.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d1b20;
}

.searchBar {
  width: 100% !important;
  background-color: #f3f7fa;
  font-size: 11px;
  color: #1d1b20;
  font-family: "Roboto";
  padding: 0px 20px 0px 0px;
}

::v-deep .pagination-container {
  background: #f2f7fa;
}

::v-deep .el-table .cell {
  word-break: normal;
}

@media (max-width: 1023px) {
  .Comtable {
    height: calc(100vh - 16rem);
  }

  .mobile-view {
    .Comtable {
      height: calc(100vh - 15.5rem);
    }
  }
}

@media (min-width: 1024px) {
  .Comtable {
    height: calc(100vh - 14rem);
  }

  .barging-card {
    margin-top: 0px !important;
  }
}

@media (min-width: 1441px) {
  .barging-card {
    height: calc(100vh - 160px);
  }

  .Comtable {
    height: calc(100vh - 15rem);
  }
}
</style>
